// extracted by mini-css-extract-plugin
export default {"extraLinks":"FooterContainer_extraLinks__c9jkv","extraLink":"FooterContainer_extraLink__pBNGa"};